import { useState } from 'react'
import IncludeExcludeIconModal from '../modals/IncludeExcludeIconModal'
import RatingIcon from '../../shared/RatingIcon'
import { ICON_DESCRIPTIONS } from '../../../utils/iconDescriptions'

/**
 * Chip verde (include) o rojo (exclude) de filtro IC multi-select.
 * @param {'include'|'exclude'} mode
 * @param {Object} filters - { include_ic, exclude_ic }
 * @param {Function} updateFilter - (key, value) => void
 * @param {boolean} autoOpen - abrir el modal al montar
 * @param {Function} onRemove - () => void
 */
export default function IncludeExcludeIconChip({ mode, filters, updateFilter, autoOpen = false, onRemove }) {
  const [open, setOpen] = useState(!!autoOpen)
  const filterKey = mode === 'include' ? 'include_ic' : 'exclude_ic'
  const selected = filters[filterKey] || []

  const handleRemove = (e) => {
    e.stopPropagation()
    if (onRemove) onRemove()
  }

  const handleConfirm = (icons) => {
    updateFilter(filterKey, icons)
  }

  const color = mode === 'include'
    ? 'bg-emerald-100 dark:bg-emerald-900/40 text-emerald-800 dark:text-emerald-200 hover:bg-emerald-200 dark:hover:bg-emerald-900/60'
    : 'bg-rose-100 dark:bg-rose-900/40 text-rose-800 dark:text-rose-200 hover:bg-rose-200 dark:hover:bg-rose-900/60'

  const prefix = mode === 'include' ? '+IC' : '−IC'
  const MAX_ICONS = 4

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        type="button"
        className={`group flex items-center gap-1 px-3 py-1 text-xs font-medium rounded-full transition-colors ${color}`}
      >
        {selected.length === 0 ? (
          <span>{prefix} (elegir)</span>
        ) : (
          <span className="flex items-center gap-0.5">
            <span className="font-semibold mr-0.5">{prefix}</span>
            {selected.slice(0, MAX_ICONS).map(name => (
              <span key={name} title={ICON_DESCRIPTIONS[name]?.title || name} className="inline-flex items-center">
                <RatingIcon iconId={name} size="xs" />
              </span>
            ))}
            {selected.length > MAX_ICONS && (
              <span className="ml-0.5">+{selected.length - MAX_ICONS}</span>
            )}
          </span>
        )}
        <span
          onClick={handleRemove}
          className="opacity-0 group-hover:opacity-100 transition-opacity ml-1 cursor-pointer"
          role="button"
          aria-label="Quitar filtro"
        >
          ✕
        </span>
      </button>
      {open && (
        <IncludeExcludeIconModal
          mode={mode}
          initialSelected={selected}
          onConfirm={handleConfirm}
          onClose={() => setOpen(false)}
        />
      )}
    </>
  )
}
